import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DirectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S2};
`

export const DirectionOptionRow = styled.div`
  /* FilterChipShell using legacy ds-system */
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 ${Spacing.S12};
  border-radius: ${DefaultValue.BorderRadius};
  cursor: pointer;

  &:hover {
    background-color: ${Color.Grey100};
  }
`
